<template>
  <div class="hs-container">
    <div class="hs-wrap">
      <div class="hs-item-wrap" v-for="(item, index) in stockList" :key="index">
        <div v-if="(index + 1) % 3 == 0">
          <div class="hs-item" 
            :class="getColor(stockList[index-itm])"
            v-for="itm in rowList"
            :key="itm"
            @click="gotoStock(stockList[index-itm])">
            <p class="name">{{stockList[index-itm].name}}</p>
            <p style="font-size: .17rem">
              <img :src="getDifference(stockList[index-itm]) > 0 ? sjIConSrc['up'] : sjIConSrc['down']" alt="" style="width: 10px; height: 8px">
              {{stockList[index-itm].dyna.LastPrice | getPrice}}
            </p>
            <p>
              <span class="difference">{{getDifference(stockList[index-itm]) > 0 ? '+' : ''}}{{getDifference(stockList[index-itm]) | getPrice}}</span>
              <span>{{getDifference(stockList[index-itm]) > 0 ? '+' : ''}}{{((getDifference(stockList[index-itm])/stockList[index-itm].statistic.PreClosePrice) * 100) | getPrice}}%</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-line"></div>
    <div class="rank-wrap">
      <div class="title">全部榜单</div>
      <div class="tab-wrap">
        <div class="rank-label-wrap">
          <div
            class="rank-label-item"
            v-for="(item, index) in rankLableList"
            :class="{active: index === rankActive}"
            :key="index"
            @click="rankClick(index)">
            {{item.label}}
          </div>
        </div>
        <div class="rank-table-th">
          <span class="name">股票名称</span>
          <span class="price align-right">最新价</span>
          <span class="rate align-right">{{rankThList[rankActive]}}</span>
        </div>
        <div class="rank-table-content">
          <div class="ranl-table-td" @click="gotoStock(item)" v-for="(item, index) in rankList" :key="index">
            <div class="name">
              <img :src="iconSrc[item.market]" alt="">
              <div>
                <p style="font-size: .17rem">{{item.SecurityName}}</p>
                {{item.symbol}}
              </div>
            </div>
            <span class="price align-right" :class="getLbColor(item.diff)">
              {{item.LsPri.toFixed(2)}}
            </span>
            <span class="rate align-right" :class="getLbColor(item.diff)">
              <span v-if="rankActive < 2">{{item.Rate > 0 ? '+' : ''}}{{rankActive === 5 ? item.lbRate : item.handleRate}}</span>
              <span v-else style="color: #666">
                <span v-if="rankActive === 5" :class="getLbColor(item.lbRate)">{{item.lbRate}}</span>
                <span v-else>{{item.handleRate}}</span>
              </span>
            </span>
          </div>
          <infinite-loading ref="rankinf" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
            <div class="center-align" slot="no-more">无更多数据</div>
            <div v-if="rankList.length === 0" slot="no-results" class="no-results">
            </div>
            <div v-else slot="no-results">
            </div>
            <div slot="spinner" class="tab-spinner center-align">正在加载...</div>
          </infinite-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { ws } from '@/websocket'
import { request } from '@/api/request'
import { mapMutations, mapState } from 'vuex'
import config from '@/utils/chart/config'
import InfiniteLoading from 'vue-infinite-loading'
export default {
  components: { InfiniteLoading },
  data () {
    return {
      rowList: [2,1,0], // 用于每行多少个指数板块
      stockList: [
        {
          name: '上证指数',
          symbol: '000001',
          market: 'sh'
        },
        {
          name: '深证成指',
          symbol: '399001',
          market: 'sz'
        },
        {
          name: '创业板指',
          symbol: '399006',
          market: 'sz'
        },
        {
          name: '中小板指',
          symbol: '399005',
          market: 'sz'
        },
        {
          name: '沪深300',
          symbol: '000300',
          market: 'sh'
        },
        {
          name: '上证50',
          symbol: '000016',
          market: 'sh'
        },
      ],
      rankActive: 0,
      rankLableList: [
        {
          label: '涨幅榜',
          type: 'up'
        },
        {
          label: '跌幅榜',
          type: 'down'
        },
        {
          label: '换手榜',
          type: 'hs'
        },
        {
          label: '涨速榜',
          type: 'zs'
        },
        {
          label: '振幅榜',
          type: 'zf'
        },
        {
          label: '量比榜',
          type: 'lb'
        },
      ],
      rankList: [],
      rankThList: ['涨跌幅', '涨跌幅', '换手率', '5分钟涨速', '振幅', '量比'],
      sjIConSrc: {
        up: require('@/assets/up-sj-icon.png'),
        down: require('@/assets/down-sj-icon.png')
      },
      iconSrc: {
        SH: require('@/assets/shicon.png'),
        SZ: require('@/assets/szicon.png')
      },
      dyna: {
        LastPrice: 0,
      },
      statistic: {
        PreClosePrice: 0
      },
      rankInterval: null
    }
  },
  computed: {
    ...mapState(['hsList'])
  },
  filters: {
    getPrice(val, region = 'CN') {
      return val !== undefined && !isNaN(val) && Number(val).toFixed(config.region[region].precision) || '--'
    }
  },
  created () {
    this.stockList = this.stockList.map(item => ({
      ...item,
      dyna: this.dyna,
      statistic: this.statistic
    }))
    if(this.hsList.length) this.stockList = this.hsList
    this.handleWSListeners('on')
    this.unsubscribeStockData()
    this.subscribeStockData()
    // this.getRankApi()
    this.rankInterval = setInterval(() => {
      this.getRankApi()
    }, 4000)
  },
  beforeDestroy() {
    ws.websocket.removeListener('onSTATISTICS', this.cbStatistics)
    ws.websocket.removeListener('onDYNA', this.cbDyna)
    this.unsubscribeStockData()
    this.setHsList(this.stockList)
    clearInterval(this.rankInterval)
    console.log('bk解绑')
  },
  methods: {
    ...mapMutations(['setStatistics', 'setDyna', 'setHsList', 'setSymbol']),
    async infiniteHandler($state) {
      let canload = await this.getRankApi()
      if (canload) $state.loaded()
      else $state.complete()
    },
    async getRankApi() {
      let res = await request.get({
        url: request.apis.quote.rankList,
        params: { type: this.rankLableList[this.rankActive].type }
      })
      this.rankList = res.Datas || []
      this.rankList = this.rankList.map(item => {
        const symbol = item.SecurityCode.replace(/[^0-9]/ig,"")
        const market = item.SecurityCode.replace(/[^A-Za-z]/g,"").toUpperCase()
        return {
          ...item,
          symbol,
          market,
          diff: item.LsPri - item.PreClPri || 0,
          isUp: item.LsPri - item.PreClPri > 0,
          handleRate: `${(item.Rate * 100).toFixed(2)}%`,
          lbRate: item.Rate.toFixed(2)
        }
      })
      return false
    },
    rankClick(index) {
      if (this.rankActive == index) return
      this.rankActive = index
      this.rankList = []
      this.$refs.rankinf.stateChanger.reset()
    },
    handleWSListeners(key) {
      ws.websocket[key]('onSTATISTICS', this.cbStatistics)
      ws.websocket[key]('onDYNA', this.cbDyna)
    },
    subscribeStockData() {
      this.unsubscribeStockData()
      for (let i = 0; i < this.stockList.length; i++) {
        let { symbol, market, name } = this.stockList[i]
        ws.websocket.safeSubscribeSTATISTICS(symbol, market,202)
        ws.websocket.safeUnsubscribeSTATISTICS(symbol, market,202)
        ws.websocket.safeSubscribeDYNA(symbol, market,202)
      }
    },
    unsubscribeStockData() {
      if (ws.websocket) {
        for (let i = 0; i < this.stockList.length; i++) {
          let { symbol, market } = this.stockList[i]
          // symbol = this.formatHKsymbol(this.stockList[i])
          ws.websocket.safeUnsubscribeDYNA(symbol, market)
          ws.websocket.safeUnsubscribeSTATISTICS(symbol, market)
        }
      }
    },
    cbStatistics(data) {
      if (data.QuoteData && data.QuoteData.StatisticsData) {
        this.stockList.forEach(item => {
          const sc = `${item.market.toUpperCase()}${item.symbol}`
          if(sc == `${data.Market.toUpperCase()}${data.Inst}`) {
            item.statistic = data.QuoteData.StatisticsData[0] || {}
          }
        })
      }
    },
    cbDyna(data) {
      // console.log(data, '======data')
      if (data.QuoteData && data.QuoteData.DynaData) {
        this.stockList.forEach(item => {
          const sc = `${item.market.toUpperCase()}${item.symbol}`
          if(sc == `${data.Market.toUpperCase()}${data.Inst}`) {
            item.dyna = data.QuoteData.DynaData[0] || {}
          }
        })
      }
    },
    gotoStock(item) {
      const { market, symbol, statistic, dyna } = item
      const index = this.stockList.findIndex(itm => item.symbol === symbol && item.market === market)
      if (index > -1) {
        this.setStatistics(statistic)
        this.setDyna(dyna)
      }
      this.$store.commit('setSymbol', {code:symbol, market})
      setTimeout(() => {
        this.$router.push({
          path: `/${market}/${symbol}.html`,
          // query: {refreshKeepAlive: true}
        })
      }, 100)
    },
    getDifference(item) {
      const { dyna = {}, statistic = {} } = item
      const val = dyna.LastPrice || 0
      const base = statistic.PreClosePrice || 0
      let f = val - base
      return f
    },
    getColor(item) {
      const { dyna = {}, statistic = {} } = item
      const val = dyna.LastPrice || 0
      const base = statistic.PreClosePrice || 0
      let f = this.getDifference(item)
      if(f > 0) return 'rise-color'
      if(f < 0) return 'fall-color'
      return 'draw-color'
    },
    getLbColor(num) {
      if (num > 0) {
        return 'rise-color'
      } else if (num < 0) {
        return 'fall-color'
      } else {
        return 'draw-color'
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
div
  box-sizing border-box
.align-right
  text-align right 
.rise-color
  color #E63535
.draw-color
  // color #333
.fall-color
  color #1BAA3C
.bg-line
  height 6px
  background #F5F5F5
.hs-wrap
  // display flex
  // flex-wrap wrap
  padding 16px
  padding-bottom 4px
  .hs-item-wrap
    > div
      display flex
      justify-content space-between
    .hs-item
      width 106px
      height 90px
      padding 12px 0
      margin-bottom 12px
      background linear-gradient(180deg,rgba(255,253,253,1) 0%,rgba(255,240,240,1) 100%)
      box-shadow 0px 0px 4px 2px rgba(0,0,0,0.05)
      border-radius 4px
      text-align center
      .difference
        margin-right 10px
      .name
        margin-bottom 7px
        color #333
      &.fall-color
        background linear-gradient(180deg,rgba(253,255,253,1) 0%,rgba(240,255,240,1) 100%);
        box-shadow 0px 0px 4px 2px rgba(0,0,0,0.05)
.rank-wrap
  padding 0 12px
  .title
    height 36px
    line-height 36px
    border-bottom 1px solid #EBEBEB
    color #333333
    font-weight 500
  .rank-label-wrap
    width 100%
    padding 8px 0
    overflow-x auto
    white-space nowrap
    border-bottom 1px solid #EBEBEB
    -ms-overflow-style none; //IE 10+
    overflow: -moz-scrollbars-none //Firefox
    &::-webkit-scrollbar
      display: none; //Safari and Chrome
  .rank-label-item
    display inline-block
    width 66px
    height 32px
    line-height 32px
    margin-left 12px
    text-align center
    font-size 14px
    color #666666
    border 1px solid #F5F5F5
    border-radius 2px
    background #F5F5F5
    &.active
      color #F43737
      border-color #F43737
      background #FFFFFF
    &:first-child
      margin-left 0
  .rank-table-th
    display flex
    justify-content space-between
    height 30px
    line-height 30px
    font-size 13px
    color #999999
  .name
    display flex
    width 0
    flex 1
  .price
    width 70px
  .rate
    width 65px
    flex 1
  .ranl-table-td
    display flex
    justify-content space-between
    align-items center
    height 50px
    .price,.rate
      font-size .17rem
    img
      width 15px
      height 10px
      margin-top 4px
      margin-right 2px
  

</style>